import { render, staticRenderFns } from "./MyShop.vue?vue&type=template&id=036566cf"
import script from "./MyShop.vue?vue&type=script&lang=js"
export * from "./MyShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports